import { css } from 'lit';

export const style = css`
  :host {
    all: initial;
    display: block;
    background-color: white;
    font-family: var(--kb-font--family);
    max-width: var(--kb-max-width);
    height: 100%;
    font-size: 1rem;
    line-height: 1;
    vertical-align: baseline;
    font-style: normal;
    font-weight: 300;
    padding: 0.25rem;
    border: 0;
    margin: 0;
    outline: 0;
  }

  :host,
  :host * {
    box-sizing: border-box;
  }

  button,
  textarea,
  input::placeholder {
    font-family: var(--kb-font--family);
    font-size: 0.85em;
  }

  p {
    margin: 0;
  }

  .container {
    display: inline-flex;
    align-items: center;
    background-color: var(--kb-clr--transparent);
    width: var(--kb-fx-32);
    margin: 0 var(--kb-fx-5);
  }

  .container:before,
  .container:after {
    content: ' ';
  }

  .profile-avatar {
    width: var(--kb-fx-32);
    height: var(--kb-fx-32);
    border-radius: 100%;
    aspect-ratio: 1 / 1;
    background-size: cover;
    object-fit: cover;
  }

  .profile-avatar {
    width: var(--kb-fx-32);
    height: var(--kb-fx-32);
    border-radius: 100%;
    aspect-ratio: 1 / 1;
    background-size: cover;
    object-fit: cover;
  }

  .talk-wrapper {
    height: 100%;
    display: grid;
    overflow: hidden;
    grid-template-columns: none;
    grid-template-rows: var(--kb-fx-64) 1fr auto var(--kb-fx-64);
  }

  .talk-wrapper.hidden-header {
    grid-template-rows: 1fr auto var(--kb-fx-64);
  }

  .talk-wrapper.hidden-footer {
    grid-template-rows: var(--kb-fx-64) 1fr;
  }

  .talk-wrapper.hidden-footer.hidden-header {
    grid-template-rows: 1fr;
  }

  :host([read-only]) .talk-wrapper {
    grid-template-rows: var(--kb-fx-64) 1fr auto;
  }

  .talk-header,
  .talk-footer {
    min-height: 24px;
  }

  .talk-header {
    box-shadow: rgba(0, 0, 0, 0.75) 0px 10px 20px -20px;
    padding: var(--kb-fx-12);
    align-items: center;
    display: flex;
    background-color: var(--kb-param-header-color);
    border-radius: 4px;
  }

  .talk-header #bot-header-title {
    font-size: var(--kb-fx-16) !important;
    line-height: var(--kb-fx-16) !important;
    padding: var(--kb-fx-0);
    margin: var(--kb-fx-0);
    margin-right: auto;
    font-weight: 100;
    overflow: hidden;
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    color: var(--kb-param-header-text-color);
  }

  .talk-panel {
    flex-grow: 1;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    padding: 0 var(--kb-fx-12);
  }

  .talk-panel > ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  .has-tail {
    position: relative;
  }

  .has-tail > .talk-message {
    position: relative;
    z-index: 1;
  }

  .has-tail::before {
    position: absolute;
    z-index: 0;
    content: '';
    bottom: 2px;
    height: 8px;
    width: 12px;
    border-radius: 100%;
    background-color: white;
  }

  .message-type--to-bot.has-tail::before {
    right: -10px;
    box-shadow: -6px 3px 0 0 var(--kb-param-user-text-background-color);
  }

  :host([read-only]) .message-type--to-bot.has-tail::before {
    bottom: 18px;
  }

  .message-type--from-bot.has-tail::before {
    left: -10px;
    box-shadow: 6px 3px 0 0 var(--kb-clr--gray-1);
  }

  .talk-message {
    display: flex;
    padding: var(--kb-fx-8);
    color: var(--kb-clr--text);
    margin-bottom: var(--kb-fx-12);
    border-radius: var(--kb-fx-12);
  }

  .talk-message > * {
    flex: 0 1 auto;
  }

  .talk-message.talk-message--to-bot {
    align-items: center;
    padding: var(--kb-fx-4) var(--kb-fx-8);
    background-color: var(--kb-param-user-text-background-color);
    margin-bottom: var(--kb-fx-16);
    margin-left: var(--kb-fx-36);
    margin-top: var(--kb-fx-16);
    color: var(--kb-param-text-color);
    border: var(--kb-fx-1) solid var(--kb-param-user-text-background-color);
  }

  .talk-message.talk-message--from-bot {
    background-color: var(--kb-clr--gray-0);
    margin-right: var(--kb-fx-36);
    border: var(--kb-tile--border);
  }

  .talk-message.talk-message--to-bot,
  .talk-message.talk-message--from-bot {
    box-shadow: var(--kb-tile--shadow);
  }

  .talk-message.talk-message--to-human {
    border: var(--kb-fx-1) var(--kb-clr--yellow-2) dashed;
    background-color: var(--kb-clr--yellow-1);
  }

  .talk-message.talk-message--to-human svg {
    stroke: var(--kb-clr--yellow-2);
    min-width: var(--kb-fx-32);
  }

  .message-timestamp {
    color: var(--kb-clr--blue-4);
    font-size: var(--kb-fx-11);
    text-align: right;
    display: block;
    margin-top: calc(-1 * var(--kb-fx-12));
    margin-bottom: var(--kb-fx-20);
    margin-right: var(--kb-fx-12);
  }

  .talk-message > .text-md {
    margin-left: var(--kb-fx-8);
  }

  .talk-message.talk-message--to-bot > .text-md {
    color: var(--kb-param-text-color);
    font-weight: 500;
    margin-left: 0;
  }

  .talk-message svg {
    vertical-align: middle;
  }

  button.icon svg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .talk-message-out {
    float: right;
  }

  .action-buttons,
  .talk-input {
    display: flex;
  }

  .action-buttons {
    box-shadow: rgba(0, 0, 0, 0.95) 0px -5px 20px -18px;
    max-height: calc(var(--kb-fx-48) + var(--kb-fx-48));
    overflow: auto;
    flex-wrap: wrap;
    gap: var(--hi-sz-4);
  }

  .action-buttons:not(.empty-slot) {
    box-shadow: 0;
    padding: var(--kb-fx-12) calc(var(--kb-fx-8) + var(--kb-fx-8) + var(--kb-fx-2) + var(--kb-fx-2) + 2.125rem)
      var(--kb-fx-4);
  }

  .action-buttons.empty-slot + .talk-footer {
    box-shadow: rgba(0, 0, 0, 0.95) 0px -5px 20px -18px;
  }

  .talk-input {
    position: sticky;
    align-items: center;
    padding: var(--kb-fx-12);
    justify-content: space-between;
    gap: var(--kb-fx-8);
  }

  .talk-input textarea,
  .feedback-survey-container textarea {
    color: var(--kb-clr--text);
    padding: var(--kb-fx-8);
    font-weight: 300;
    width: 100%;
    opacity: 1;
    resize: none;
    overflow: auto;
    background-color: white;
    border: var(--kb-fx-1) solid var(--kb-clr--blue-4);
  }

  .talk-input textarea {
    border-radius: var(--kb-fx-12);
    height: var(--kb-fx-34);
    line-height: 1.2;
    overflow: hidden;
  }

  .talk-input textarea:focus-visible {
    animation: activeElement 4s ease-in-out infinite;
  }

  @keyframes activeElement {
    0% {
      border-color: var(--kb-clr--blue-4);
      background-color: white;
    }
    50% {
      border-color: var(--kb-clr--blue-1);
      background-color: var(--kb-clr--blue-1-disabled);
    }
    100% {
      border-color: var(--kb-clr--blue-4);
      background-color: white;
    }
  }

  .feedback-survey-container textarea {
    border-radius: var(--kb-fx-4);
    line-height: 1.35;
  }

  .feedback-controls {
    display: flex;
    justify-content: flex-start;
    margin-top: calc(-1 * var(--kb-fx-8));
    margin-bottom: var(--kb-fx-4);
  }

  .feedback-survey-container {
    display: flex;
    flex-direction: column;
    gap: var(--kb-fx-8);
    border: var(--kb-tile--border);
    border-radius: var(--kb-fx-4);
    box-shadow: var(--kb-tile--shadow);
    padding: var(--kb-fx-8);
    margin-bottom: var(--kb-fx-8);
  }

  .feedback-survey-label {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .feedback-survey-label p {
    font-size: 0.85em;
  }

  .feedback-survey-container textarea {
    width: auto;
  }

  .feedback-survey-form {
    display: flex;
    flex-direction: column;
    gap: var(--kb-fx-8);
  }

  .action-buttons ::slotted(button),
  button[data-method],
  button.action {
    text-overflow: ellipsis;
    will-change: box-shadow;
    vertical-align: middle;
    display: inline-block;
    white-space: nowrap;
    text-align: center;
    cursor: pointer;
    padding: var(--kb-fx-4) var(--kb-fx-8);
    border-radius: var(--kb-fx-4);
    border: var(--kb-fx-1) solid var(--kb-clr--gray-3);
    background-color: var(--kb-clr--blue-4);
    color: var(--kb-clr--gray-1);
    line-height: 1.55;
    font-size: var(--kb-fx-14);
    font-weight: 300;
    font-family: var(--kb-font--family);
  }

  .action-buttons ::slotted(button) {
    margin-right: var(--kb-fx-2);
    margin-left: var(--kb-fx-2);
  }

  .action-buttons ::slotted(button:hover:not([disabled])),
  button[data-method]:hover:not([disabled]),
  button.action:hover:not([disabled]) {
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  }

  .action-buttons ::slotted(button:focus:not([disabled])),
  button[data-method]:focus:not([disabled]),
  button.action:focus:not([disabled]) {
    outline: var(--kb-fx-1) solid var(--kb-clr--outline);
    outline-offset: var(--kb-fx-2);
  }

  .action-buttons ::slotted(button:hover:active:not([disabled])),
  button[data-method]:hover:active:not([disabled]),
  button.action:hover:active:not([disabled]) {
    box-shadow: none;
  }

  button.close {
    width: 10%;
    justify-self: flex-end;
  }

  button.icon {
    background-color: var(--kb-clr--transparent);
    border-color: var(--kb-clr--transparent);
    color: var(--kb-clr--gray-5);
    text-overflow: ellipsis;
    will-change: box-shadow;
    vertical-align: middle;
    display: inline-block;
    white-space: nowrap;
    text-align: center;
    cursor: pointer;
    padding: var(--kb-fx-2);
    aspect-ratio: 1 / 1;
    height: var(--kb-fx-34);
    width: var(--kb-fx-34);
    border-radius: var(--kb-fx-4);
  }

  button:disabled,
  button[disabled] {
    color: var(--kb-clr--gray-3);
    pointer-events: none;
    cursor: not-allowed;
  }

  textarea:disabled {
    cursor: not-allowed;
    pointer-events: none;
  }

  :focus:not([disabled]) {
    outline: var(--kb-fx-1) solid var(--kb-clr--outline);
    outline-offset: var(--kb-fx-2);
  }

  .icon:hover:not([disabled]) {
    border: var(--kb-fx-1) var(--kb-clr--gray-4) solid;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  }

  .icon:hover:disabled,
  .icon:focus:disabled {
    box-shadow: none;
    outline: none;
  }

  .talk-panel-footer-anchor {
    margin-top: var(--kb-fx-12);
  }

  .talk-panel-header-anchor {
    margin-bottom: var(--kb-fx-12);
  }

  .loading-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .loading-container__message {
    margin: var(--kb-fx-6);
    font-size: 0.85em;
  }

  .loading-container__loader {
    transform: rotateZ(45deg);
    perspective: 1000px;
    border-radius: 50%;
    width: var(--kb-fx-32);
    height: var(--kb-fx-32);
    color: var(--kb-clr--loader-1);
  }

  .loading-container__loader:before,
  .loading-container__loader:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: inherit;
    height: inherit;
    border-radius: 50%;
    transform: rotateX(70deg);
    animation: 1s spin linear infinite;
  }

  .loading-container__loader:after {
    color: var(--kb-clr--loader-2);
    transform: rotateY(70deg);
    animation-delay: 0.4s;
  }

  @keyframes rotate {
    0% {
      transform: translate(-50%, -50%) rotateZ(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotateZ(360deg);
    }
  }

  @keyframes rotateccw {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotate(-360deg);
    }
  }

  @keyframes spin {
    0%,
    100% {
      box-shadow: 0.2em 0px 0 0px currentcolor;
    }
    12% {
      box-shadow: 0.2em 0.2em 0 0 currentcolor;
    }
    25% {
      box-shadow: 0 0.2em 0 0px currentcolor;
    }
    37% {
      box-shadow: -0.2em 0.2em 0 0 currentcolor;
    }
    50% {
      box-shadow: -0.2em 0 0 0 currentcolor;
    }
    62% {
      box-shadow: -0.2em -0.2em 0 0 currentcolor;
    }
    75% {
      box-shadow: 0px -0.2em 0 0 currentcolor;
    }
    87% {
      box-shadow: 0.2em -0.2em 0 0 currentcolor;
    }
  }

  .has-tip {
    position: relative;
    display: inline-block;
    border-bottom: var(--kb-fx-1) dotted black;
  }

  .has-tip > .tip-text {
    visibility: hidden;
    background-color: var(--kb-clr--gray-4);
    color: #fff;
    text-align: center;
    border-radius: var(--kb-fx-4);
    padding: var(--kb-fx-4) var(--kb-fx-6);
    position: absolute;
    z-index: 1;
    opacity: 0;
    transition: opacity 0.3s;
    top: -100%;
    left: -100%;
  }

  .has-tip.to-left > .tip-text {
    top: 10%;
    left: 0;
    transform: translate(-110%);
  }

  .has-tip.to-right > .tip-text {
    top: 10%;
    left: 120%;
  }

  .has-tip:focus > .tip-text,
  .has-tip:hover > .tip-text {
    visibility: visible;
    opacity: 1;
  }

  #icon_dislike_outline path,
  #icon_dislike_fill path {
    fill: var(--kb-clr--dislike);
  }

  #icon_like_fill path,
  #icon_like_outline path {
    stroke: var(--kb-clr--like);
  }

  #icon_like_fill path {
    fill: var(--kb-clr--like);
  }
`;
